import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["autoFocus", "dataKey", "disabled", "inlineSize", "inputMode", "dataSelenium", "name", "onChange", "placeholder", "renderExtraIcons", "type", "value", "displayMode", "onFocus", "onBlur"];
import { forwardRef } from 'react';
import { Data } from 'signup-constants/signupData/Data';
import { DisplayMode } from './DisplayMode';
import { TextInput as BaseTextInput } from 'foundations-components/transitional/components/TextInput';
import { View } from 'foundations-components/transitional/components/View';
import { getShouldShowSidePanel } from '../utils/getShouldShowSidePanel';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { Step } from 'signup-constants/Step';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TextInput = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      autoFocus,
      dataKey,
      disabled,
      inlineSize,
      inputMode,
      dataSelenium,
      name,
      onChange,
      placeholder,
      renderExtraIcons,
      type,
      value,
      displayMode = DisplayMode.Label,
      onFocus,
      onBlur
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const shouldShowSidePanel = getShouldShowSidePanel();
  const {
    isExtraSmall
  } = useResponsiveness();
  const {
    currentStep
  } = useCurrentStep();
  const isExtraSmallInLandingPage = currentStep === Step.LandingPage && isExtraSmall;
  const isPasswordField = dataKey === Data.Password;
  const shouldRenderExternalIcon = isPasswordField && renderExtraIcons;
  const textInput = /*#__PURE__*/_jsx(BaseTextInput, Object.assign({
    autoComplete: type === 'password' ? 'new-password' : 'on',
    autoFocus: autoFocus,
    "data-selenium": dataSelenium || dataKey,
    disabled: disabled,
    inputMode: inputMode,
    inputRef: ref,
    name: name
  }, displayMode === DisplayMode.Placeholder ? {
    placeholder
  } : null, {
    type: type,
    value: value,
    onBlur: event => {
      if (onBlur) {
        onBlur(event, dataKey);
      }
    },
    onChange: ({
      target
    }) => onChange(target.value),
    onFocus: onFocus
  }, rest));
  return /*#__PURE__*/_jsx(View, {
    maxInlineSize: inlineSize || (!shouldShowSidePanel || isExtraSmallInLandingPage ? '100%' : '360px'),
    position: "relative",
    children: shouldRenderExternalIcon ? /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      gap: 8,
      children: [textInput, renderExtraIcons()]
    }) : textInput
  });
});
export default TextInput;